import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { remittanceFilter } from 'src/app/interfaces/iresponse';
import { SuperAdminService } from 'src/app/services/apiCalls/superAdminService/super-admin.service';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';
import { BootstrapNotifyService } from 'src/app/services/bootstrap-notify/bootstrap-notify.service';
import { UtilService } from 'src/app/services/utilService/util.service';
import { genderType } from 'src/app/users/enrol-riders/enrol-riders.component';

type optionType = 'agent'|'not-agent'| '';
@Component({
  selector: 'app-confirm-remittance',
  templateUrl: './confirm-remittance.component.html',
  styleUrl: './confirm-remittance.component.css'
})
export class ConfirmRemittanceComponent implements OnInit, OnDestroy {
  breadCrumb: any;
  loadingRemittance: boolean = false;
  showData: boolean = true;
  remittanceHistory = [];
  sub: Subscription;
  loadingZones: boolean = false;
  agents: genderType[] = [
    {id: 0, name: 'Select Agent', value: ''}
  ];
  categories: genderType[] = [
    {id: 0, name: 'Select Category', value: ''}
  ];
  zones: genderType[] = [
    {id: 0, name: 'Select Zone', value: ''}
  ];
  currentDate = new Date(Date.now()).toISOString();
  status : genderType[] = [
    {id: 1, name: 'Select status', value: ''},
    {id: 2, name: 'Successful', value: 'successful'},
    {id: 3, name: 'Pending', value: 'pending'},
    {id: 4, name: 'Failed', value: 'failed'},
  ]
  constructor(
    private superAdminService: SuperAdminService, 
    private userService: UserService,
    private utilService: UtilService,
    private alertService: BootstrapNotifyService){}
  filterForm = new FormGroup({
    from: new FormControl( '', Validators.required),
    to: new FormControl( '', Validators.required),
    agent_id: new FormControl( '', Validators.required),
    category: new FormControl('', Validators.required),
    zone_id: new FormControl({value: '', disabled: true}, Validators.required),
    status: new FormControl('', Validators.required),
    search: new FormControl('', Validators.required),

  })

    ngOnInit(): void {
      this.breadCrumb  = {
        name: 'Remittance Report',
        parent: 'Settings',
        subLink: null
      };
      this.getTransactionRemittance({to: this.currentDate})
      this.getAgents();
      this.getCategories();

      this.sub = this.filterForm.get('category').valueChanges.subscribe((categoryValue: string) => {
        const zoneControl = this.filterForm.get('zone_id');
        if(categoryValue === ''){
          zoneControl.disable();
        }else{
          zoneControl.enable();
          this.getZones(categoryValue);
        }
      })
    }


    getTransactionRemittance(filters: remittanceFilter){
      this.loadingRemittance = true;
      this.showData = false;
      this.superAdminService.getRemittances(filters).subscribe({
        next: (response)=>{
          this.remittanceHistory = response;
          this.utilService.startDatatable('revenue-reports'); 
          this.loadingRemittance = false;
          this.showData = true;
        },
        error: (err)=>{
          this.showData = true;
          this.utilService.startDatatable('revenue-reports'); 
          this.loadingRemittance = false
        }
      }).add(()=> this.loadingRemittance = false)
    }
  getAgents(){
    this.superAdminService.getAllAgentsForFilter().subscribe({
      next: (res)=>{
        const {data}=res;
        this.agents.push(...this.setOptionFields( [], data, 'agent'));
      }
    })
  }

  getCategories(){
    this.userService.getCategories('').subscribe({
      next: (response)=>{
        const filter = response.filter((c)=> c.status.toLowerCase() === 'active');
        this.categories.push(...this.setOptionFields( [] , filter, 'not-agent'))
      }
    })
  }

  getZones(categoryId?: string){
    this.loadingZones = true;
    this.userService.getAllZones('', categoryId).subscribe({
      next: (response)=>{
        this.loadingZones = false;
        const zones = response.data;
        this.zones = this.setOptionFields([] , zones, 'not-agent');
      }
    })
  }

  setOptionFields(originalArray : genderType[], passedArray : any[], selectCase: optionType){
    const selectArray:genderType[] = passedArray.map((o)=>{
      return {
        id: o.id,
        name: selectCase === 'agent' ? o.full_name : o.name,
        value:  selectCase === 'agent' ? String(o.id) : o.name
      }
    })
    return [...originalArray, ...selectArray];
  }

  getControlValue(cntrl: string){
    const control = this.filterForm.get(cntrl)?.value?.toLowerCase();
    return control;
  }

  onFormValidate(){
    if( 
      this.getControlValue('to') > this.currentDate && this.getControlValue('from') > this.currentDate  ||
      this.getControlValue('to') !== '' && this.getControlValue('from') === '' || 
      this.getControlValue('to') === '' && this.getControlValue('from') !== '' ||
      this.getControlValue('from') > this.getControlValue('to') || this.getControlValue('to') > this.currentDate
     ){
      return true;
    }
    if(
      this.getControlValue('agent_id') !== '' || 
      this.getControlValue('from') !== '' || 
      this.getControlValue('to') !== '' ||
      this.getControlValue('category') !== '' || 
      this.getControlValue('zone_id') !== '' ||
      this.getControlValue('status') !== '' || 
      this.getControlValue('search') !== ''
    ) return false;
      return true;
  } 
  onFormReset(){
    this.filterForm.reset({
      agent_id: '',
      from: '',
      to: '',
      category: '',
      zone_id: '',
      status: '',
      search: ''
    });
  }

  onFilterForm(){
    const from = this.getControlValue('from')
    const to = this.getControlValue('to');
    const agent_id = this.getControlValue('agent_id');
    const category = this.getControlValue('category');
    const zone_id = this.getControlValue('zone_id');
    const status = this.getControlValue('status');
    const search = this.getControlValue('search');
    const controls = {from, to, category, agent_id, zone_id, status, search};
    this.getTransactionRemittance(controls);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
